@if (checkPermissions()) {
  @if (!inlinePanel) {
    <div
      class="relative inline-block"
      (mouseenter)="isCartPopoverVisible.set(true)"
      (mouseleave)="isCartPopoverVisible.set(false)">
      <p-overlayBadge
        [value]="getCartBadgeLabel(shoppingCartCount())"
        severity="danger"
        class="shopping-cart-icon"
        data-testid="shopping-cart-badge"
        [ngClass]="{ 'hide-badge': shoppingCartCount() == 0 }">
        @if (mobileFullViewTrigger) {
          <button
            #cartButton
            class="icon-with-circle icon-with-circle-lg"
            type="button"
            (click)="onCartClick($event)">
            <i class="pi pi-shopping-cart"></i>
          </button>
        } @else {
          <button
            #cartButton
            class="icon-with-circle icon-with-circle-lg"
            type="button"
            [routerLink]="route.cart()"
            data-testid="shopping-cart-button"
            >
            <i class="pi pi-shopping-cart"></i>
          </button>
        }
              <span data-testid="shopping-cart-count" class="hidden">{{ shoppingCartCount() }}</span>
      </p-overlayBadge>

      @if (isCartPopoverVisible()) {
        <div
          class="absolute right-0 top-full z-50 mt-2 w-96 max-w-full rounded-lg bg-white shadow-xl ring-1 ring-black ring-opacity-5 dark:bg-surface-800 md:max-w-[20rem]"
          role="dialog"
          aria-modal="true">
          <div class="absolute -top-2 right-4">
            <div class="size-4 rotate-45 border-l border-t border-surface-200 bg-white dark:border-surface-700 dark:bg-surface-800 shadow-xl"></div>
          </div>
          <div class="relative z-10">
            <div class="flex flex-col lg:max-h-[26rem] max-h-[18rem]">
              <div class="sticky top-0 bg-white dark:bg-surface-800 z-10 p-3 border-b border-surface-200 dark:border-surface-700">
                <h4 class="font-semibold">{{ 'cart.title' | translate }}</h4>
              </div>
              <div class="flex-1 overflow-y-auto p-3">
                @if (isCartLoading()) {
                  <div class="space-y-4 mt-3">
                    @for (_ of [1,2,3]; track _) {
                      <div class="flex items-center gap-3 border-b border-surface-200 dark:border-surface-700 pb-3">
                        <p-skeleton width="64px" height="64px" styleClass="rounded"></p-skeleton>
                        <div class="flex-1 space-y-2">
                          <p-skeleton height="14px" width="60%"></p-skeleton>
                          <p-skeleton height="12px" width="40%"></p-skeleton>
                          <div class="flex justify-between mt-2">
                            <p-skeleton height="14px" width="80px"></p-skeleton>
                            <p-skeleton height="14px" width="60px"></p-skeleton>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                } @else {
                  @if (cartProducts() && cartProducts().length > 0) {
                    @for (item of cartProducts(); track item; let first = $first; let last = $last) {
                      <div
                        class="flex items-center gap-3"
                        [ngClass]="{ 'border-b border-surface-200 dark:border-surface-700 pb-3': !last, 'pt-3': !first }">
                        <div class="w-20 h-20 items-center flex flex-shrink-0 ltr:mr-3 rtl:ml-3">
                          <img
                            class="block m-auto rounded max-w-[5rem] max-h-[5rem] w-auto h-auto object-cover"
                            [src]="item.imagePath || 'assets/no-image.png'"
                            [alt]="item.articleNo"
                            (error)="item.imagePath = 'assets/no-image.png'" />
                        </div>
                        <div class="flex-1">
                          <div class="font-semibold text-sm line-clamp-1" [title]="item.articleDescription">
                            {{ item.articleDescription }}
                          </div>
                          <div class="text-xs text-slate-600 dark:text-surface-300" [title]="item.articleNo">
                            {{ 'catalogue.articleNo' | translate }}: {{ item.articleNo }}
                          </div>
                          <div class="mt-1 flex items-center justify-between">
                            <span class="text-md font-semibold">
                              {{ 'cart.quantity' | translate }}: {{ item.numberOfItems }}
                            </span>
                            <span class="text-md font-semibold">
                              {{ (item.numberOfItems * item.aufpPrice2) | currency: 'EUR':'symbol':'1.2-2':locale() }}
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  } @else {
                    <div class="text-center text-sm text-slate-500 dark:text-surface-300 py-6">
                      {{ 'cart.emptyCart' | translate }}
                    </div>
                  }
                }
              </div>
              <div class="sticky bottom-0 bg-white dark:bg-surface-800 z-10 p-3 border-t border-surface-200 dark:border-surface-700 text-right">
                <p-button
                  [label]="'cart.viewCart' | translate"
                  icon="pi pi-arrow-right"
                  size="small"
                  [routerLink]="route.cart()" />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="mobile-cart-panel">
      <div class="mobile-cart-panel-body">
        @if (isCartLoading()) {
          <div class="space-y-4 mt-3">
            @for (_ of [1,2,3]; track _) {
              <div class="flex items-center gap-3 border-b border-surface-200 dark:border-surface-700 pb-3">
                <p-skeleton width="64px" height="64px" styleClass="rounded"></p-skeleton>
                <div class="flex-1 space-y-2">
                  <p-skeleton height="14px" width="60%"></p-skeleton>
                  <p-skeleton height="12px" width="40%"></p-skeleton>
                  <div class="flex justify-between mt-2">
                    <p-skeleton height="14px" width="80px"></p-skeleton>
                    <p-skeleton height="14px" width="60px"></p-skeleton>
                  </div>
                </div>
              </div>
            }
          </div>
        } @else {
          @if (cartProducts() && cartProducts().length > 0) {
            @for (item of cartProducts(); track item; let first = $first; let last = $last) {
              <div
                class="flex items-center gap-3 py-3"
                [ngClass]="{ 'border-b border-surface-200 dark:border-surface-700': !last }">
                <div class="w-20 h-20 items-center flex flex-shrink-0 ltr:mr-3 rtl:ml-3">
                  <img
                    class="block m-auto rounded max-w-[5rem] max-h-[5rem] w-auto h-auto object-cover"
                    [src]="item.imagePath || 'assets/no-image.png'"
                    [alt]="item.articleNo"
                    (error)="item.imagePath = 'assets/no-image.png'" />
                </div>
                <div class="flex-1">
                  <div class="font-semibold text-sm line-clamp-2" [title]="item.articleDescription">
                    {{ item.articleDescription }}
                  </div>
                  <div class="text-xs text-slate-600 dark:text-surface-300" [title]="item.articleNo">
                    {{ 'catalogue.articleNo' | translate }}: {{ item.articleNo }}
                  </div>
                  <div class="mt-1 flex items-center justify-between">
                    <span class="text-md font-semibold">
                      {{ 'cart.quantity' | translate }}: {{ item.numberOfItems }}
                    </span>
                    <span class="text-md font-semibold">
                      {{ (item.numberOfItems * item.aufpPrice2) | currency: 'EUR':'symbol':'1.2-2':locale() }}
                    </span>
                  </div>
                </div>
              </div>
            }
          } @else {
            <div class="text-center text-sm text-slate-500 dark:text-surface-300 py-6">
              {{ 'cart.emptyCart' | translate }}
            </div>
          }
        }
      </div>
      <div class="mobile-cart-panel-footer">
        <p-button
          [label]="'cart.viewCart' | translate"
          icon="pi pi-arrow-right"
          size="small"
          [routerLink]="route.cart()"
          (onClick)="onViewCartClick()" />
      </div>
    </div>
  }
}
